import { render, staticRenderFns } from "./TelemetryView.vue?vue&type=template&id=23deab70&"
import script from "./TelemetryView.vue?vue&type=script&lang=js&"
export * from "./TelemetryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports